// src/web/client/src/components/RootEntry.jsx
//
// Declarative guard for the '/' route: an INSTALLED merchant opening the app
// from the Shopify admin must land in the app — never on the marketing page.
//
// The old behavior gated the rescue-redirect on a legacy localStorage 'token'
// (written only by AuthSuccess on the device where OAuth ran), so an installed
// merchant on a NEW device/browser saw "Start 14-Day Free Trial" inside their
// own admin. The reliable signal was in the URL all along: Shopify only
// renders an app iframe for an INSTALLED app, and every embedded load carries
// ?shop=&host= (+ a Shopify-signed id_token).
//
// Guardrails, by construction:
//  - `!code`: during an OAuth callback (?code&state&shop) this component is
//    fully transparent — that case belongs to ShopifyParamHandler (untouched).
//  - The query string is preserved VERBATIM in the redirect: the #98
//    authoritative ?shop= and the entry id_token ride on it.
//  - Not embedded (top-level marketing visitor) → Landing, byte-identical.
//  - Embedded WITHOUT ?shop= → Landing with its embedded notice, unchanged
//    (deliberately conservative — only the proven-install case redirects).

import React from "react";
import { Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";

export default function RootEntry() {
  const params = new URLSearchParams(window.location.search);
  const isEmbedded = window.top !== window.self || !!params.get("host");

  if (isEmbedded && params.get("shop") && !params.get("code")) {
    // SPA navigation (no reload — App Bridge stays alive), search preserved.
    return <Navigate to={`/dashboard${window.location.search}`} replace />;
  }

  return <Landing />;
}
